import React from 'react';
import { Department } from '../../types';

const DEPT_CONFIG: Record<Department, { label: string; color: string; bg: string }> = {
  gestor:     { label: 'Gestor',      color: '#f97316', bg: 'rgba(249,115,22,0.12)' },
  financiero: { label: 'Financiero',  color: '#3b82f6', bg: 'rgba(59,130,246,0.12)' },
  imprenta:   { label: 'Imprenta',    color: '#a855f7', bg: 'rgba(168,85,247,0.12)' },
  dtf:        { label: 'DTF',         color: '#14b8a6', bg: 'rgba(20,184,166,0.12)' },
  almacen:    { label: 'Almacén',     color: '#22c55e', bg: 'rgba(34,197,94,0.12)'  },
  embalaje:   { label: 'Embalaje',    color: '#f59e0b', bg: 'rgba(245,158,11,0.12)' },
};

export function DeptBadge({ dept, size = 'sm' }: { dept: Department; size?: 'xs' | 'sm' | 'md' }) {
  const cfg = DEPT_CONFIG[dept];
  const padding = size === 'xs' ? '2px 6px' : size === 'md' ? '5px 12px' : '3px 8px';
  const fontSize = size === 'xs' ? '10px' : size === 'md' ? '13px' : '11px';
  return (
    <span style={{ color: cfg.color, background: cfg.bg, padding, fontSize, fontFamily: 'JetBrains Mono, monospace', borderRadius: 4, fontWeight: 600, letterSpacing: '0.03em', border: `1px solid ${cfg.color}33` }}>
      {cfg.label.toUpperCase()}
    </span>
  );
}

export function deptColor(dept: Department): string {
  return DEPT_CONFIG[dept]?.color ?? '#9896ac';
}

export { DEPT_CONFIG };
